module.exports = __webpack_public_path__ + "img/ip-cctvimg-4.c57e7369.png";